import React from "react"
import { graphql } from "gatsby"

import Layout from "../components/layout"
import Seo from "../components/seo"
import ScmView from "../views/ScmView"
import { useMenuState } from "../lib/hooks"

const ScmPage = ({ data, location }) => {
  const model = data.allStrapiPage.nodes[0]
  const files = data.allFile.edges.filter(({ node }) => (node.sourceInstanceName === "data"))
  const [menu_state, on_menu_button_click] = useMenuState()

  return (
    <Layout on_menu_button_click={on_menu_button_click}>
      <Seo title="Supply Chain Management" image="https://cms.lilogy.com/uploads/LIL_Oclean_Sanitizer_Group_4487d6a2bd.png" slug="scm" />
      <ScmView model={model} lottiefiles={files} menu_state={menu_state} />
    </Layout>
  )
}

export default ScmPage

export const query = graphql`
  query ScmPageQuery {
    allFile(filter: {sourceInstanceName: {in: ["images", "data"]}}) {
      edges {
        node {
          relativePath
          publicURL
          extension
          sourceInstanceName
        }
      }
    }
    allStrapiPage(filter: {strapiId: {eq: 4}}) {
      nodes {
        Body
        id
        carousels {
          copy
          id
          name
        }
        lottiefile
        name
        panel {
          TextAlign
          body
          color
          id
          lottiefile
          name
        }
        panels {
          TextAlign
          body
          color
          id
          images {
            url
            width
            name
            mime
            height
            caption
            alternativeText
          }
          lottiefile
          name
        }
        photo {
          alternativeText
          caption
          height
          id
          mime
          size
          url
          formats {
            thumbnail {
              url
            }
          }
        }
        profile {
          id
          linkedin
          name
          title
          photo {
            url
          }
        }
      }
    }
  }
`
